import clsx from "clsx";

interface IconProps {
	className?: string
	theme?: 'light' | 'dark'
}

export const XIcon: React.FC<IconProps> = ({ className, theme= 'dark' }) => {
	return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      className={clsx(className, 'w-[1.2rem] h-[1.2rem]')}
      viewBox="0 0 14 12"
    >
      <path
        fill={theme === 'light' ? '#FF77A8' : '#131313'}
        d="m8.3835 5.123 4.131-5.1198h-1.8438l-3.153 3.9102L4.7205.0032H.7065l4.6836 6.546-4.4016 5.454H2.833l3.423-4.242 3.0366 4.242h4.014L8.3835 5.123Zm-1.428 1.77-.867-1.2114L2.7225.9794h1.386l2.7168 3.7902.8658 1.212 3.6108 5.0454h-1.386L6.9555 6.893Z"
      />
    </svg>
  );
}